import React from "react";

export const CameraIcon: React.FC = () => {
  return (
  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_7042_124)">
      <path d="M22.1571 8.30198C21.9062 8.11125 21.5849 8.05102 21.2838 8.13133L16.5557 9.4564V7.86029C16.5557 7.30818 16.1039 6.85645 15.5518 6.85645H5.67397C5.12186 6.85645 4.67013 7.30818 4.67013 7.86029C4.67013 8.41241 5.12186 8.86414 5.67397 8.86414H14.548C14.548 10.8919 14.5279 12.9197 14.548 14.9374C14.548 15.5799 14.548 16.2223 14.548 16.8648H4.46936V10.129C4.46936 9.57687 4.01763 9.12514 3.46552 9.12514C2.9134 9.12514 2.46167 9.57687 2.46167 10.129V17.8686C2.46167 18.4207 2.9134 18.8725 3.46552 18.8725H15.5518C16.1039 18.8725 16.5557 18.4207 16.5557 17.8686V15.9914L21.334 17.0455C21.4042 17.0656 21.4745 17.0656 21.5548 17.0656C21.7857 17.0656 22.0065 16.9852 22.1872 16.8447C22.4282 16.654 22.5587 16.3629 22.5587 16.0617V9.08498C22.5587 8.77379 22.4081 8.47264 22.1571 8.28191V8.30198ZM20.551 14.837L16.5557 13.9536V11.5544L20.551 10.4301V14.837Z" fill="white"/>
    </g>
    <defs>
      <clipPath id="clip0_7042_124">
        <rect width="24.0923" height="24.0923" fill="white" transform="translate(0.453857 0.823242)"/>
      </clipPath>
    </defs>
  </svg>
  );
};
